export const APP_CONFIG = {
    emailJs: {
        publicKey: 'Hd232LSXgZ9-if65G',
        service: 'service_6z1uvjj',
        contact_template: 'template_hcrqwg8',
        ftcf_template: 'template_qxj0ldk'
    },
    phoneLink: 'tel:+16478556177',
    phone: '+1(647)855-6177',
    email: 'info@orientalbiz.ca',
    emailLink: 'mailto:info@orientalbiz.ca',
    address: 'Unit B, 92 Carrier Dr Etobicoke, ON M9W 5R1',
    address2line: 'Unit B, 92 Carrier Dr Etobicoke, ON M9W 5R1',
    addressLink: 'https://www.google.com/maps?q=Unit+B,+92+Carrier+Dr+Etobicoke,+ON+M9W+5R1',
    gmapLink: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.667565439881!2d-79.61428052353388!3d43.738232371098356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3b0739948a07%3A0x915eac668971b5ea!2s92%20Carrier%20Dr%20Unit%20B%2C%20Etobicoke%2C%20ON%20M9W%205R1!5e0!3m2!1sen!2sca!4v1743804826619!5m2!1sen!2sca',
    whatsAppLink: `https://wa.me/+16478556177?text=${encodeURIComponent("Hello, I\'m interested in your services. Could you please let me know your available times to connect? Thank you!")}`,
    facebookLink: "https://www.facebook.com/oriental2022?mibextid=LQQJ4d",
    instaLink: "https://www.instagram.com/orientalbusinesssolutions?igsh=MTVyczU5MHpiajgydQ==",
    linkedInLink: "https://www.linkedin.com/in/orientalbusiness",

}
